import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import FileSaver from 'file-saver';
import { Skeleton, Space, Typography, Row, Col, Button, Spin, notification } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import EbzPopover from 'components/EbzPopover';
import EbzFilterGroup from 'components/EbzFilterGroup';
import EbzButton from 'components/EbzButton';
import EbzTable from 'components/EbzTable';
import payoutReportsAPI from 'services/payoutApi';
import Alert from 'components/Alert';
import { useNavigate } from 'react-router-dom';
import { NotitficationIcon } from 'utils/icons';
import './index.scss';
import { PAYOUT_CYCLE } from 'constants';
import {
  getCummaltivePayoutColumns,
  getCummaltiveSummaryCards,
  cummalativePayoutReportfiltersArr
} from './const';

function CumlativePayoutReport() {
  const isPayoutReport = useSelector((state) => state.user.planPermissions.can_view_payout_report);

  const [openModal, setModalOpen] = useState(false);
  const [cummaltiveSummaryCards, setCummaltiveSummaryCards] = useState([]);
  const [cummaltiveSummaryReports, setCummaltiveSummaryReports] = useState([]);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [partnerPayoutMonthFilters, setpartnerPayoutMonthFilters] = useState({});
  const [api, contextHolder] = notification.useNotification();
  const [downloadReport, setDownloadReport] = useState(false);
  const [payoutCycle, setPayoutCycle] = useState(null);
  const currentDate = dayjs();
  const financialYear =
    currentDate.month() >= 3 // month() is 0-based (0 = Jan)
      ? currentDate.year()
      : currentDate.year() - 1;
  console.log(financialYear, 'financialYear');

  const navigate = useNavigate();

  const clearFiltersCallBackfun = () => {
    setModalOpen(!openModal);
  };

  const fetchCummalativeSummaryCards = async (request) => {
    setSummaryLoading(true);
    const response = await payoutReportsAPI.getCummalativeReportCard(request);
    if (!response?.success) {
      Alert('something went wrong', 'Please contact support team for this', 'error');
      setSummaryLoading(false);
      return;
    }
    setCummaltiveSummaryCards(response?.data?.payout_cummalative_summary?.[0]);
    setPayoutCycle(response?.data?.payout_cycle);
    setSummaryLoading(false);
  };

  const fetchCummalativePayoutReports = async (reportFilter) => {
    setTableLoading(true);

    const request = {
      filters: reportFilter
    };
    const response = await payoutReportsAPI.getCummalativePayoutReports(request);
    if (!response?.success) {
      Alert('something went wrong', 'Please contact support team for this', 'error');
      setTableLoading(false);
      return;
    }
    setCummaltiveSummaryReports(response?.data?.fetch_payout_cummalative_reports);
    setTableLoading(false);
  };

  const downloadCummalativePayoutReports = async () => {
    const request = {
      filters: partnerPayoutMonthFilters
    };
    const response = await payoutReportsAPI.downloadablePayoutCummalativeReport(request);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes('application/json')) {
      Alert('something went wrong', 'Please contact support team for this', 'error');
    } else {
      api.open({
        message: 'Excel Export',
        description: 'Report has been generated.',
        icon: <NotitficationIcon />
      });
      FileSaver.saveAs(response.data, `Payout_Cummalative_report.xlsx`);
    }
  };

  const applyFiltersCallbackfunc = (checkFilters) => {
    setModalOpen(!openModal);
    const cleanedFilters = checkFilters.filter(
      (item) => item != null && Object.keys(item).length > 0
    );
    const mergedDict = cleanedFilters.reduce(
      (prevObj, currentObj) => ({ ...prevObj, ...currentObj }),
      {}
    );
    setpartnerPayoutMonthFilters(mergedDict);
    fetchCummalativePayoutReports(mergedDict);
  };

  const handleOpen = (record) => {
    navigate(`reports/${record}`);
  };

  const downloadPayout = async (payoutMonth) => {
    let request = {};
    request = {
      mandatory_check: { year_month: payoutMonth },
      download_key: 'PAYOUT'
    };
    const response = await payoutReportsAPI.downloadBulkReports(request);
    if (response.success) {
      window.open(response?.data?.s3_url);
    } else {
      console.log('something went wrong');
      Alert('something went wrong', 'Please contact support team for this', 'error');
    }
  };
  const downloadInvoice = async (payoutMonth) => {
    setDownloadReport(payoutMonth);
    let request = {};
    request = {
      mandatory_check: { year_month: payoutMonth },
      download_key: 'INVOICE'
    };
    const response = await payoutReportsAPI.downloadBulkReports(request);
    if (response.success) {
      window.open(response?.data?.s3_url);
    } else {
      console.log('something went wrong');
      Alert('something went wrong', 'Please contact support team for this', 'error');
    }
    setDownloadReport(false);
  };
  const handlePayoutDownload = (record) => {
    downloadPayout(record);
  };
  const handleInvoiceDownload = (record) => {
    downloadInvoice(record);
  };
  const cummaltivePayoutColumns = getCummaltivePayoutColumns(
    handleOpen,
    handlePayoutDownload,
    handleInvoiceDownload,
    downloadReport
  );
  const cummalativeSummaryCards = getCummaltiveSummaryCards(cummaltiveSummaryCards);

  const getFetchData = () => {
    const fyEnd = String(financialYear + 1).slice(-2);
    const reportFilter = {
      year_selected: `${financialYear}-${fyEnd}`
    };
    setpartnerPayoutMonthFilters(reportFilter);
    fetchCummalativeSummaryCards();
    fetchCummalativePayoutReports(reportFilter);
  };

  useEffect(() => {
    if (isPayoutReport) {
      getFetchData();
    } else {
      navigate('/');
    }
  }, [isPayoutReport]);

  return (
    <div className="cummalative-payout-div">
      <Skeleton
        loading={summaryLoading}
        paragraph={{
          rows: 1,
          width: ['100%', '80%'],
          style: { backgroundColor: '#fff' }
        }}
        title={{ style: { backgroundColor: '#fff' } }}
        style={{ backgroundColor: '#fff', padding: 8, borderRadius: 6 }}
        active
      >
        <div className="payout-report-funnel">
          {payoutCycle && (
            <div className="last-updated-at-div">
              <Typography.Text className="last-updated-at-content">
                Payout Cycle: {PAYOUT_CYCLE[payoutCycle].label}
              </Typography.Text>
            </div>
          )}

          <div className="main-funnel">
            {cummalativeSummaryCards.length > 1 &&
              cummalativeSummaryCards.map((item) => (
                <div className="cards">
                  <div className="main-img">
                    <div>{item?.rect}</div>
                    <div className="img-overlap">{item?.icon}</div>
                  </div>
                  <div className="funnel-text-div">
                    <Typography.Text className="title">{item?.label}</Typography.Text>
                    <Typography.Text className="text">{item?.value}</Typography.Text>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Skeleton>

      <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Col>
          <Space>
            <EbzPopover
              placement="bottomLeft"
              content={
                <EbzFilterGroup
                  filters={cummalativePayoutReportfiltersArr}
                  disableToday
                  apply={applyFiltersCallbackfunc}
                  clear={clearFiltersCallBackfun}
                />
              }
              open={openModal}
              onOpenChange={setModalOpen}
              trigger="click"
              overlayStyle={{
                width: '400px'
              }}
              overlayClassName="ebz-filters-popover"
            >
              <EbzButton size="large" className="ebz-filters-btn">
                Filter &nbsp; &nbsp; &nbsp;
                <DownOutlined />
              </EbzButton>
            </EbzPopover>
          </Space>
        </Col>
        <Col>
          <Button
            type="primary"
            size="large"
            onClick={() => downloadCummalativePayoutReports()}
            disabled={!cummaltiveSummaryReports.length > 0}
          >
            Export
          </Button>
        </Col>
      </Row>
      <Spin spinning={tableLoading}>
        <Row>
          <EbzTable
            columns={cummaltivePayoutColumns}
            // eslint-disable-next-line no-underscore-dangle
            rowKey={(r) => `${r.title}_type`}
            dataSource={cummaltiveSummaryReports}
            loading={false}
            pagination={false}
            isPagination={false}
            sticky
            thBgColor="#EEEDF1"
            size="middle"
            scroll={
              cummaltiveSummaryReports.length > 0 && {
                y: 420,
                scrollToFirstRowOnChange: true
              }
            }
          />
        </Row>
        {contextHolder}
      </Spin>
    </div>
  );
}

export default CumlativePayoutReport;
